import React, { Component } from 'react';
import { connect } from 'react-redux'
import { loadFoundIn, loadHA, loadShanghai, loadFounders, loadPartners, loadContributors } from "../../actions/about";
import './About.css'
import BodyClassName from 'react-body-classname';
import { Link } from 'react-router-dom';

class About extends Component {

  componentDidMount(){
    let {loadFoundIn, loadHA, loadFounders, loadPartners, loadContributors, loadShanghai} = this.props
    loadHA()
    loadFoundIn()
    loadFounders()
    loadPartners()
    loadContributors()
    loadShanghai()
  }

  renderTexts(text) {
    let segs = text.split('\n').map((a, i)=>{
      return <div key={i}>{a}</div>
    })
    return <div className={"content-text-lines"}>{segs}</div>
  }

  render() {
    let {
      ha, foundIn,
      leftColWidth, rightColWidth,
      loadingAbout, loadingAboutError,
      founders, partners, contributors,
      shanghai,
    } = this.props
    if(loadingAbout){
      return null
    }else if(loadingAboutError){
      return null
    }
    return <BodyClassName className={`about`}>
      <div className={"about-content"}>
        <div className={"mcontent-navs"}>
          <Link className={"nav-home"} to={'/'}>HOME</Link>
        </div>
        {foundIn &&
        <div className={"content-container content-found-in"}>
          <div className={"content-text-left"} style={{width:leftColWidth}}>{foundIn.title}</div>
          <div className={"content-text-right"}  style={{width:rightColWidth}}>
            <div className={"about-found-in"}>
              {this.renderTexts(foundIn.content)}
            </div>
          </div>
        </div>
        }
        {founders &&
        <div className={"content-container content-found-in"}>
          <div className={"content-text-left"} style={{width:leftColWidth}}>{founders.title}</div>
          <div className={"content-text-right"}  style={{width:rightColWidth}}>
            <div className={"about-found-in"}>
              {this.renderTexts(founders.content)}
            </div>
          </div>
        </div>
        }
        {partners &&
        <div className={"content-container content-found-in"}>
          <div className={"content-text-left"} style={{width:leftColWidth}}>{partners.title}</div>
          <div className={"content-text-right"}  style={{width:rightColWidth}}>
            <div className={"about-found-in"}>
              {this.renderTexts(partners.content)}
            </div>
          </div>
        </div>
        }
        {shanghai &&
        <div className={"content-container content-found-in"}>
          <div className={"content-text-left"} style={{width:leftColWidth}}>{shanghai.title}</div>
          <div className={"content-text-right"}  style={{width:rightColWidth}}>
            <div className={"about-found-in"}>
              {this.renderTexts(shanghai.content)}
            </div>
          </div>
        </div>
        }
        {contributors &&
        <div className={"content-container content-found-in"}>
          <div className={"content-text-left"} style={{width:leftColWidth}}>{contributors.title}</div>
          <div className={"content-text-right"}  style={{width:rightColWidth}}>
            <div className={"about-found-in"}>
              {this.renderTexts(contributors.content)}
            </div>
          </div>
        </div>
        }
        {ha &&
        <div className={"content-container"}>
          <div className={"content-text-left"} style={{width:leftColWidth}}>{ha.title}</div>
          <div className={"content-text-right"}  style={{width:rightColWidth}}>
            <div className={"about-ha"}>
              {this.renderTexts(ha.content)}
            </div>
          </div>
        </div>
        }
      </div>
    </BodyClassName>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    partners: state.about.partners,
    foundIn: state.about.foundIn,
    shanghai: state.about.shanghai,
    ha: state.about.ha,
    contributors: state.about.contributors,
    founders: state.about.founders,
    loadingAbout: state.work.loadingAbout,
    loadingAboutError: state.works.loadingAboutError,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadHA: ()=>dispatch(loadHA()),
    loadShanghai: ()=>dispatch(loadShanghai()),
    loadFoundIn: ()=>dispatch(loadFoundIn()),
    loadFounders: ()=>dispatch(loadFounders()),
    loadPartners: ()=>dispatch(loadPartners()),
    loadContributors: ()=>dispatch(loadContributors()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(About)


